import React, { useState } from 'react'
import { Send, Copy, Download } from 'lucide-react'
import AITool from '../components/AITool'
import './ContentTools.css'

const ContentTools: React.FC = () => {
  const [activeTool, setActiveTool] = useState('blog')

  const tools = [
    {
      id: 'blog',
      name: 'Blog Generator',
      description: 'Generate engaging blog posts from topics or keywords',
      icon: '📝',
      endpoint: '/.netlify/functions/free-test',
      fields: [
        { name: 'topic', label: 'Topic or Keyword', type: 'text' as const, placeholder: 'e.g., Artificial Intelligence in Healthcare' },
        { name: 'tone', label: 'Tone', type: 'select' as const, options: ['Professional', 'Casual', 'Academic', 'Conversational'] },
        { name: 'length', label: 'Length', type: 'select' as const, options: ['Short (300-500 words)', 'Medium (500-800 words)', 'Long (800-1200 words)'] }
      ]
    },
    {
      id: 'social',
      name: 'Social Media Captions',
      description: 'Create engaging captions for social media posts',
      icon: '📱',
      endpoint: '/.netlify/functions/generate-caption',
      fields: [
        { name: 'content', label: 'Content Description', type: 'text' as const, placeholder: 'e.g., Product launch, event, announcement' },
        { name: 'platform', label: 'Platform', type: 'select' as const, options: ['Instagram', 'Twitter', 'Facebook', 'LinkedIn', 'TikTok'] },
        { name: 'tone', label: 'Tone', type: 'select' as const, options: ['Professional', 'Casual', 'Humorous', 'Inspirational', 'Educational'] }
      ]
    },
    {
      id: 'email',
      name: 'Email Writer',
      description: 'Generate professional emails based on purpose and tone',
      icon: '📧',
      endpoint: '/.netlify/functions/generate-email',
      fields: [
        { name: 'purpose', label: 'Email Purpose', type: 'text' as const, placeholder: 'e.g., Meeting request, follow-up, introduction' },
        { name: 'recipient', label: 'Recipient Type', type: 'select' as const, options: ['Client', 'Colleague', 'Manager', 'Customer', 'Partner'] },
        { name: 'tone', label: 'Tone', type: 'select' as const, options: ['Formal', 'Professional', 'Friendly', 'Casual'] },
        { name: 'context', label: 'Additional Context', type: 'textarea' as const, placeholder: 'Any additional details or specific points to include' }
      ]
    },
    {
      id: 'product',
      name: 'Product Description Generator',
      description: 'Create compelling product descriptions from features',
      icon: '🛍️',
      endpoint: '/.netlify/functions/generate-product-description',
      fields: [
        { name: 'product', label: 'Product Name', type: 'text' as const, placeholder: 'e.g., Wireless Bluetooth Headphones' },
        { name: 'features', label: 'Key Features', type: 'textarea' as const, placeholder: 'List the main features and benefits of your product' },
        { name: 'target', label: 'Target Audience', type: 'select' as const, options: ['General', 'Professionals', 'Students', 'Athletes', 'Tech Enthusiasts'] },
        { name: 'style', label: 'Writing Style', type: 'select' as const, options: ['Persuasive', 'Informative', 'Luxury', 'Casual', 'Technical'] }
      ]
    }
  ]

  return (
    <div className="content-tools">
      <div className="page-header">
        <h1>Content Tools</h1>
        <p>Generate engaging content for blogs, social media, emails, and products</p>
      </div>

      <div className="tools-tabs">
        {tools.map((tool) => (
          <button
            key={tool.id}
            className={`tab-button ${activeTool === tool.id ? 'active' : ''}`}
            onClick={() => setActiveTool(tool.id)}
          >
            <span className="tool-icon">{tool.icon}</span>
            <span className="tool-name">{tool.name}</span>
          </button>
        ))}
      </div>

      <div className="tool-content">
        {tools.map((tool) => (
          <div key={tool.id} className={`tool-panel ${activeTool === tool.id ? 'active' : ''}`}>
            <AITool
              title={tool.name}
              description={tool.description}
              endpoint={tool.endpoint}
              fields={tool.fields}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ContentTools 